import React, { useState, useReducer, useCallback, useRef } from 'react';
import { MapGeoFence } from "../geoMap/GeoMap";
import './schedForm.scss'; // Your existing styles
import { useMutation, useQuery, useQueryClient } from 'react-query';
import api from '../../services/api';

const submitSchedule = async (post) => {
  const res = await api.post('/api/osint/schedule/',  post );
  return res.data;
}

// Define the container style for the map
const mapContainerStyle = {
  width: '100%',
  height: '400px',
};

// Define the initial center of the map (could be your default location)
// Use CDMX coordinates as an example
const defaultCenter = {
    lat: 19.4326,
    lng: -99.1332,
};

// Define options for the map
const options = {
  disableDefaultUI: false,
  zoomControl: true,
};

const SchedForm = (props) => {
    // We will show a form to create a new schedule
    // The form will have the following fields:
    // task_name: this is a select with the available tasks: ["perform_geo_fence", "perform_geo_location"]
    // frequency: this is a number select input with preset values: [15, 30, 60, 90 , 120]
    // start_time: this is a datetime input
    // end_time: this is a datetime input or could be null if the schedule is indefinite
    // enabled, 
    // metadata: this is a json field with the target and the case
    // The form will have a submit button
    const mapRef = useRef(null);
    const circleRef = useRef(null);
    const queryClient = useQueryClient();
    const [error, setError] = useState(null);

    const reducer = (state, action) => {
        switch (action.type) {
            case 'UPDATE_FIELD':
                return {
                    ...state,
                    [action.field]: action.value,
                };
            case 'SET_LOCATION':
                return {
                    ...state,
                    lat: action.lat,
                    lng: action.lng,
                };
            case 'SET_RADIUS':
                return {
                    ...state,
                    radius: action.radius,
                };
            default:
                return state;
        }
    };

    const initialSchedule = {
        task_name: 'perform_geo_location',
        frequency: 30,
        start_time: new Date(),
        lat: defaultCenter.lat,
        lng: defaultCenter.lng,
        radius: 1000,
        early_stop: null,
        end_time: null,
        enabled: true,
        metadata: {"cases": [], "targets": []},
    };

    // I we got a case_id or a target_id we will add it to the metadata
    if (props.caseId) {
        initialSchedule.metadata.cases.push(props.caseId);
    }
    if (props.targetId) {
        initialSchedule.metadata.targets.push(props.targetId);
    }
    const [schedule, dispatch] = useReducer(reducer, initialSchedule);

    const handleChange = (e) => {
        dispatch({ type: 'UPDATE_FIELD', field: e.target.name, value: e.target.value });
    };

    // Handle map click to set location
    const onMapClick = useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    dispatch({ type: 'SET_LOCATION', lat, lng });
    }, []);

    const onCircleChange=useCallback((event) => {
        if (mapRef.current) {
        const newRadius = circleRef.current.getRadius();
        dispatch({ type: 'SET_RADIUS', radius: newRadius });
        }
    }, []);

    const handleReset = (e) => {
        dispatch({ type: 'UPDATE_FIELD', field: 'task_name', value: 'perform_geo_location' });
        dispatch({ type: 'UPDATE_FIELD', field: 'frequency', value: 30 });
        dispatch({ type: 'UPDATE_FIELD', field: 'start_time', value: new Date() });
        dispatch({ type: 'UPDATE_FIELD', field: 'end_time', value: null });
        dispatch({ type: 'UPDATE_FIELD', field: 'enabled', value: true });
        dispatch({ type: 'UPDATE_FIELD', field: 'radius', value: 1000 });
        dispatch({ type: 'UPDATE_FIELD', field: 'early_stop', value: null });
        dispatch({ type: 'SET_LOCATION', lat: defaultCenter.lat, lng: defaultCenter.lng });
        // if we have props.caseId or props.targetId we will add it to the metadata
        if (props.caseId) {
            dispatch({ type: 'UPDATE_FIELD', field: 'metadata', value: {"cases": [props.caseId], "targets": []} });
        }
        else if (props.targetId) {
            dispatch({ type: 'UPDATE_FIELD', field: 'metadata', value: {"cases": [], "targets": [props.targetId]} });
        } else {
                dispatch({ type: 'UPDATE_FIELD', field: 'metadata', value: {"cases": [], "targets": []} });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await queryClient.invalidateQueries('schedules');
            // We need to insert the lat, lng, radius and early_stop as objects inside the metadata and delete them from the main object
            // We will copy the metadata field to a new object and then delete the fields
            const schedule_to_submit = {...schedule};
            if (! props.caseId && ! props.targetId) {
             schedule_to_submit.metadata = JSON.parse(schedule_to_submit.metadata);
            }
            console.log(JSON.stringify(schedule_to_submit));
            if (schedule_to_submit.task_name === 'perform_geo_fence') {
                schedule_to_submit.metadata.lat = schedule_to_submit.lat;
                schedule_to_submit.metadata.lng = schedule_to_submit.lng;
                schedule_to_submit.metadata.radius = schedule_to_submit.radius;
                schedule_to_submit.metadata.early_stop = schedule_to_submit.early_stop;
            }
            delete schedule_to_submit.lat;
            delete schedule_to_submit.lng;
            delete schedule_to_submit.radius;
            delete schedule_to_submit.early_stop;
            console.log("schedule_to_submit:");
            console.log(JSON.stringify(schedule_to_submit));
            await submitSchedule(schedule_to_submit);
            // handleReset();
            // if we got props.onSchedSubmit we will call it
            if (props.onSubmit) {
                props.onSubmit();
            }
        } catch (error) {
            setError(error);

        }
    };

    if (error) return <div>An error occurred: {error.message}</div>;
    return (
        <div className="schedForm">
            <h1>Create Schedule</h1>
            <form onSubmit={handleSubmit}>
                <div className="formGroup">
                    <label>Task Name</label>
                    <select name="task_name" onChange={handleChange}>
                    <option value="perform_geo_location" selected={schedule.task_name === "perform_geo_location"}>Perform Geo Location</option>
                        <option value="perform_geo_fence" selected={schedule.task_name === "perform_geo_fence"}>Perform Geo Fence</option>
                    </select>
                </div>
                {
                    schedule.task_name === 'perform_geo_fence' && <>
                        {/* Google Map Integration */}
                        <div className="mapContainer">
                            <MapGeoFence
                                mapContainerStyle={mapContainerStyle}
                                defaultCenter={defaultCenter}
                                options={options}
                                onMapClick={onMapClick}
                                onDragEnd={onMapClick}
                                onCircleChange={onCircleChange}
                                mapRef={mapRef}
                                circleRef={circleRef}
                                lat={schedule.lat}
                                lng={schedule.lng}
                                radius={schedule.radius}
                            />
                        </div>
                         {/* Display selected latitude and longitude */}
                        {schedule.lat && schedule.lng && (
                            <div className="selectedLocation">
                            <p>
                                Selected Location: Latitude: {schedule.lat.toFixed(6)}, Longitude: {schedule.lng.toFixed(6)}
                            </p>
                            </div>
                        )}
                         <div className="formGroup">
                            <label>Radius</label>
                            <select name="radius" onChange={handleChange}>
                                <option value="1000" selected={schedule.radius === 1000}>1000m</option>
                                <option value="2000" selected={schedule.radius === 2000}>2000m</option>
                                <option value="3000" selected={schedule.radius === 3000}>3000m</option>
                            </select>
                        </div>
                         <div className="formGroup">
                            <label>Early Stop</label>
                            <select name="early_stop" onChange={handleChange}>
                                <option value="never" selected={schedule.early_stop === "never"}>Never</option>
                                <option value="break_in" selected={schedule.early_stop === "break_in"}>Break-In</option>
                                <option value="break_out" selected={schedule.early_stop === "break_out"}>Break-Out</option>
                            </select>
                        </div>
                    </>
                }
                <div className="formGroup">
                    <label>Frequency</label>
                    <select name="frequency" onChange={handleChange}>
                        <option value="15" selected={schedule.frequency === 15}>15 mins</option>
                        <option value="30" selected={schedule.frequency === 30}>30 mins</option>
                        <option value="60" selected={schedule.frequency === 60}>60 mins</option>
                        <option value="90" selected={schedule.frequency === 90}>90 mins</option>
                        <option value="120" selected={schedule.frequency === 120}>120 mins</option>
                    </select>
                </div>
                <div className="formGroup">
                    <label>Start Time</label>
                    <input type="datetime-local" name="start_time" onChange={handleChange} />
                </div>
                <div className="formGroup">
                    <label>End Time</label>
                    <input type="datetime-local" name="end_time" onChange={handleChange} />
                </div>
                <div className="formGroup">
                    <label>Enabled</label>
                    <input type="checkbox" name="enabled" onChange={handleChange} checked={schedule.enabled}/>
                </div>
                
                 {
                    (!props.caseId && !props.targetId) &&
                    <div className="form-group">
                    <label>Metadata</label>
                    <textarea type="json" name="metadata" id="metadata" onChange={handleChange} value={JSON.stringify(schedule.metadata,null, 2)}/>
                     </div>
                 }
                <button type="reset" className='resetButton' onClick={handleReset}>Reset</button> <button type="submit" className='submitButton'>Submit</button>
            </form>
        </div>
    );
    
};

export default SchedForm;